import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function OfferSection() {
  return <section id="offer-section" className="py-24 bg-white" data-id="element-179">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-180">
        <FadeIn data-id="element-181">
          <div id="offer-card" className="p-8 md:p-12 text-center border-4 border-amber-100 rounded-3xl bg-amber-50/30" data-id="element-182">
            <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl" data-id="element-183">
              Recupera tu metabolismo y tu confianza hoy mismo
            </h2>

            <p className="mb-8 text-xl text-gray-700 leading-relaxed" data-id="element-184">
              Acceso inmediato al protocolo completo por un pago único. No es un
              gasto, es la inversión más inteligente en tu salud pro-edad.
            </p>

            <div className="mb-10" data-id="element-185">
              <span className="inline-block px-3 py-1 mb-4 text-sm font-bold text-white bg-red-500 rounded-full uppercase tracking-wider" data-id="element-186">
                🔥 Descuento del 68%
              </span>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-187">
                <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-188">
                  $19.97 USD
                </span>
              </div>
              <span className="block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-189">
                Precio Especial Hoy
              </span>
              <span className="text-6xl font-extrabold text-emerald-600" data-id="element-190">
                $6.39{' '}
                <span className="text-2xl text-gray-500 font-medium" data-id="element-191">USD</span>
              </span>
              <p className="mt-3 text-sm text-red-500 font-semibold" data-id="element-192">
                ⏰ Oferta por tiempo limitado
              </p>
            </div>

            <Button fullWidth href="https://pay.hotmart.com/C104846627C?off=6wnk3ot1" className="text-xl py-6 mb-6" data-id="element-193">
              ¡SÍ, QUIERO ACTIVAR MI METABOLISMO AHORA!
            </Button>

            <div className="flex flex-col items-center justify-center gap-4 text-sm text-gray-500" data-id="element-194">
              <div className="flex items-center gap-2" data-id="element-195">
                <svg className="w-5 h-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-196">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-197" />
                </svg>
                Pago 100% seguro vía Hotmart
              </div>
              <div className="flex items-center gap-2" data-id="element-198">
                <svg className="w-5 h-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-199">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-200" />
                </svg>
                Acceso instantáneo por email
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}